import { useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import TabSinPagos from '../components/TabSinPagos';
import TabPagoProporcionalSinMeses from '../components/TabPagoProporcionalSinMeses';
import TabPagoProporcionalMensualidad from '../components/TabPagoProporcionalMensualidad';
import TabClientesCancelados from '../components/TabClientesCancelados';
import TabResumenClientesCancelados from '../components/TabResumenClientesCancelados';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
        </div>
    );
}

export default function ReporteClientesValoresPage() {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    return (
        <>
            <Box sx={{ width: '100%' }}>
                {/* Título principal */}
                <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
                        📑 Reporte de Clientes / Seguimiento de Valores - Softnet
                    </Typography>
                </Box>

                {/* Tabs */}
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={tabValue} onChange={handleTabChange}>
                        <Tab label="Sin Pagos Registrados" id="tab-0" aria-controls="tabpanel-0" />
                        <Tab label="Pagado Proporcional Sin Mensualidad" id="tab-1" aria-controls="tabpanel-1" />
                        <Tab label="Pagado Proporcional y 1 Mes" id="tab-2" aria-controls="tabpanel-2" />
                        <Tab label="Clientes Cancelados" id="tab-3" aria-controls="tabpanel-3" />
                        <Tab label="Resumen Clientes Retirados" id="tab-4" aria-controls="tabpanel-4" />
                    </Tabs>
                </Box>

                {/* Tab Panels */}
                <TabPanel value={tabValue} index={0}>
                    <TabSinPagos />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <TabPagoProporcionalSinMeses />
                </TabPanel>
                <TabPanel value={tabValue} index={2}>
                    <TabPagoProporcionalMensualidad />
                </TabPanel>
                <TabPanel value={tabValue} index={3}>
                    <TabClientesCancelados />
                </TabPanel>
                <TabPanel value={tabValue} index={4}>
                    <TabResumenClientesCancelados />
                </TabPanel>
            </Box>
        </>
    );
}
